import * as React from 'react';
import { UitkHeading } from 'uitk-react-text';
import { ActivityDestinationViewSearch, ActivityTextSize } from '../../../../common/__generated__/api';
import { AnchoredText } from './anchored-text';

export interface ActivityTextTileProps {
  activityTiles: ActivityDestinationViewSearch.ActivityTiles[];
}

export const ActivityTextTile: React.FC<ActivityTextTileProps> = ({ activityTiles }): JSX.Element | null => {
  if (activityTiles.length === 0) {
    return null;
  }

  return (
    <section className="all-x-padding-three all-y-margin-three" data-testid="activity-text-tile-section">
      {(activityTiles as ActivityDestinationViewSearch.ActivityTextTileInlineFragment[]).map((activityTile, index) => {
        let textElement = null;
        let anchoredElement = null;
        if (activityTile.text) {
          switch (activityTile.size) {
            case ActivityTextSize.LARGE:
              textElement = (
                <UitkHeading tag="h2" size={4} key={`text-tile-${index}`} data-testid="activity-text-tile">
                  {activityTile.text}
                </UitkHeading>
              );
              break;
            case ActivityTextSize.MEDIUM:
              textElement = (
                <UitkHeading tag="h2" size={6} key={`text-tile-${index}`} data-testid="activity-text-tile">
                  {activityTile.text}
                </UitkHeading>
              );
              break;
            case ActivityTextSize.SMALL:
            default:
              textElement = (
                <p key={`text-tile-${index}`} className="uitk-type-200" data-testid="activity-text-tile">
                  {activityTile.text}
                </p>
              );
          }
        }

        if (activityTile.anchoredText) {
          anchoredElement = (
            <AnchoredText key={`anchored-text-tile-${index}`} anchoredText={activityTile.anchoredText} />
          );
        }

        return [textElement, anchoredElement];
      })}
    </section>
  );
};
